import { css } from "@emotion/css"

//
import TotalClientsSpend from "./1_TotalClientsSpend"
import TotalNetSpend from "./2_TotalNetSpend"
import TotalBilled from "./3_TotalBilled"
import TotalAC from "./4_TotalAC"

const styles = {
  container: css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    width: 100%;
    gap: var(--spacing-m, 1rem);
  `,
}

export default function Indicators() {
  return (
    <div className={styles.container}>
      <div>
        <TotalClientsSpend />
      </div>
      <div>
        <TotalNetSpend />
      </div>
      <div>
        <TotalBilled />
      </div>
      <div>
        <TotalAC />
      </div>
    </div>
  )
}
